<section class="main-content">
  @if (userDetails) {
    <div class="row mt-4">
      <div class="col-lg-3">
        <div class="card card-h-100 p-3">
          <div class="row">
            <div class="col-12">
              <div class="title-flex">
                <h4 class="main-title">
                  <i class="fas fa-user-friends pad-right-10"></i>
                  <span class="mt-0" (dblclick)="estimationUpdateForMigrationRateCard()">User Profile</span>
                </h4>
              </div>
              <hr class="title-line">
            </div>
          </div>
          <div class="row" style="margin-top: 60px;">
            <div class="col-12 text-center">
              <div class="user-container mt-2 mb-3">
                <div class="user text-center">
                  <img [src]="profileImage" class="main-profile-img" />
                  <span class="icon" (click)="openProfilePicDialog()"><i class="fa fa-edit"></i></span>
                </div>
              </div>
              <p class="dark-font semi-bold mb-1 mt-4 text-center">{{userDetails.firstName}}
                {{userDetails.lastName}}
              </p>
              <div class="mb-1 mt-3 text-center">
                <p>{{userDetails.roleDisplayName}}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="col-lg-9">
        <div class="card card-h-100 p-3">
          <div class="row">
            <div class="col-12">
              <div class="title-flex">
                <h4 class="main-title">
                  <i class="fas fa-user-friends pad-right-10"></i>
                  <span class="mt-1 pad-left-10"> Profile Details </span>
                </h4>
              </div>
              <hr class="title-line">
            </div>
          </div>
          <div class="row mt-2">
            <div class="col-sm-4 col-12">
              <p class="dark-font semi-bold mb-1">Full Name</p>
              <p>{{userDetails.firstName}} {{userDetails.lastName}}</p>
            </div>
            <div class="col-sm-4 col-12 ">
              <p class="dark-font semi-bold mb-1">Email</p>
              <p>{{userDetails.userName}}</p>
            </div>
            <div class="col-sm-4 col-12 ">
              <p class="dark-font semi-bold mb-1">Phone Number</p>
              @if (userDetails.phoneNumber) {
                <p> {{userDetails.phoneNumber| phoneFormat: getDialCode(userDetails.phoneDialCode):'(###) ###-####'}}
                </p>
              }
            </div>
            <div class="col-sm-4 col-12 ">
              <p class="dark-font semi-bold mb-1">MMI Title</p>
              <p>{{userDetails.designationName}}</p>
            </div>
            <div class="col-sm-4 col-12 ">
              <p class="dark-font semi-bold mb-1">Country</p>
              <p>{{userDetails.countryName}}</p>
            </div>
            <div class="col-sm-4 col-12 ">
              <p class="dark-font semi-bold mb-1">State</p>
              <p>{{userDetails.stateName}}</p>
            </div>
            <div class="col-sm-4 col-12 ">
              <p class="dark-font semi-bold mb-1">City</p>
              <p>{{userDetails.cityName}}</p>
            </div>
            <div class="col-sm-4 col-12 ">
              <p class="dark-font semi-bold mb-1">Zip Code</p>
              <p>{{userDetails.zipCode}}</p>
            </div>
            <div class="col-sm-4 col-12 ">
              <p class="dark-font semi-bold mb-1">Status</p>
              <p>{{userDetails.isActive==true?'Active':'InActive'}}</p>
            </div>
            <div class="col-sm-4 col-12 ">
              <p class="dark-font semi-bold mb-1">Timezone</p>
              <p>{{userDetails.timezoneName}}</p>
            </div>
            <form [formGroup]="changeProfileFormGroup">
              <div class="row">
                <div class="col-sm-4 col-12 ">
                  @if (isopenChangePasswordScreen) {
                    <tui-textfield tuiTextfieldSize="m">
                    <label tuiLabel>New Password</label>
                    <input
                        placeholder="New Password"
                        tuiInput
                        type="password"
                       formControlName="password"
                    />
                    <tui-icon tuiPassword />
                </tui-textfield>
                  }
                  @if (changeProfileFormGroup.get('password')?.errors?.required && changeProfileFormGroup.get('password')?.touched && isopenChangePasswordScreen) {
                    <div
                      class="error-message">
                      New Password is required !
                    </div>
                  }
                  @if (changeProfileFormGroup.get('password')?.errors?.pattern && changeProfileFormGroup.get('password')?.touched && isopenChangePasswordScreen) {
                    <div
                      class="error-message">
                      New Password must contain at least one lowercase letter, one uppercase
                      letter, one digit, and one special character.
                    </div>
                  }
                </div>
                <div class="col-sm-4 col-12">
                  @if (isopenChangePasswordScreen) {
                    <tui-textfield tuiTextfieldSize="m">
                    <label tuiLabel> New Confirm Password</label>
                    <input
                        placeholder="New Password"
                        tuiInput
                        type="password"
                       formControlName="confirmPassword"
                    />
                    <tui-icon tuiPassword />
                </tui-textfield>
                  }
                  @if (changeProfileFormGroup.get('confirmPassword')?.errors?.required && changeProfileFormGroup.get('confirmPassword')?.touched && isopenChangePasswordScreen) {
                    <div
                      class="error-message">
                      New Confirm Password is required !
                    </div>
                  }
                  @if (changeProfileFormGroup.errors?.mismatch && changeProfileFormGroup.get('confirmPassword')?.touched && isopenChangePasswordScreen) {
                    <div
                      class="error-message">
                      Password not match!
                    </div>
                  }
                </div>
                @if (!isopenChangePasswordScreen) {
                  <div class="col-sm-4 col-12 text-end">
                    <button appearance="outline" size="s" tuiButton type="button" class="text-end"
                      (click)="openChangePasswordScreen()">
                      Change Password
                    </button>
                  </div>
                }
                @if (isopenChangePasswordScreen) {
                  <div class="col-sm-4 col-12">
                    <button appearance="primary" tuiButton size="m" type="button"
                      class="tui-space_right-3 tui-space_bottom-3"
                      [disabled]="changeProfileFormGroup.invalid"
                    (click)="changePassword(changeProfileFormGroup.value)">Save</button>
                    <button appearance="outline" size="m" tuiButton type="button"
                      (click)="cancelPassword()"
                    class="tui-space_right-3 tui-space_bottom-3">Cancel</button>
                  </div>
                }
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  }
</section>

<ng-template [tuiDialogOptions]="{ closable: false,size: 's'}" [(tuiDialog)]="isProfilePicDialog">
  <div class="dialog-content">
    <h6 class="dialog-main-title">Change Profile Picture</h6>
    <hr class="title-line mt-1 mb-2">
    <div class="col-lg-12 mt-3">
      <form [formGroup]="changeProfileFormGroup">
        @if (!changeProfileFormGroup.get('profilePic')?.value) {
            <!-- <tui-input-files formControlName="profilePic">
            <input accept="image/*" capture="user" title="Choose Profile Pic"
              tuiInputFiles />
            </tui-input-files> -->
            <label tuiInputFiles>
                  <input
                      tuiInputFiles
                      formControlName="profilePic"
                      accept="image/*"
                      capture="user"
                      title="Choose Profile Pic"
                  />
                  Choose Profile Pic
              </label>
          }
          <tui-files>
            @if ($safeNavigationMigration(changeProfileFormGroup.get('profilePic')?.valueChanges) | async; as file) {
              <tui-file
              [file]="file" (remove)="removeFile()"></tui-file>
            }
          </tui-files>
        </form>
      </div>

      <div class="col-lg-12 mt-3">
        <div class="row">
          <div class="col-lg-4 col-md-4"></div>
          @if (profilePicImageDisplay) {
            <div class="col-lg-4 col-md-4  d-flex justify-content-center">
              <div class="image">
                <div class="img text-center image-box-border image-circle">
                  <img class="sec-square-img image-circle" [src]="profilePicImageDisplay">
                  <span class="icon"><i (click)="removeFile()" class="fa fa-times-circle delete"></i></span>
                </div>
              </div>
            </div>
          }
        </div>
      </div>

      <div class="dialog-actions mt-1">
        <div class="col-12 mt-4">
          <div class="row mt-2">
            <div class="col-6">
              <button appearance="outline" size="m" tuiButton type="button"
                (click)="closeProfilePicDialog()"
              class="tui-space_right-3 tui-space_bottom-3">Cancel</button>
            </div>
            <div class="col-6 text-end">
              <button appearance="primary" tuiButton size="m" type="button" class="tui-space_bottom-3"
              (click)="changeProfilePic()">Upload</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </ng-template>